import { createDecorator } from 'components/form'
import { metaPath } from 'util/metaPath'
import { createUnidadeSaudeEquipeMicroareaCalculator } from 'view/visualizacaoTerritorial/calculator-visualizacaoTerritorial'

import { TerritorioMapaBuscaFormModel } from './model-territorioMapaBusca'

const meta = metaPath<TerritorioMapaBuscaFormModel>()

export const createTerritorioMapaBuscaFormCalculator = [
  createDecorator(...createUnidadeSaudeEquipeMicroareaCalculator(meta)),
]
